const ctx = require.context("", true, /.vue$/);
// 参照node_modules\element-ui\src\index.js编写
// 组件必须有name，才会放进install，才会被Vue.use
const components = [];
ctx.keys().forEach((key) => {
  components.push(ctx(key).default);
});

const install = (Vue, options) => {
  components.forEach((component) => {
    component.name && Vue.component(component.name, component);
  });
};

/* istanbul ignore if */
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install
};
